import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { YMMetricHelper, createMetric } from '@beef/metric';
import { getAccountType } from "../../../../utils/analytics";
import { selectUserAuth } from "../store/selectors";
export var FooterMetric = /*#__PURE__*/function (_YMMetricHelper) {
  _inherits(FooterMetric, _YMMetricHelper);
  var _super = _createSuper(FooterMetric);
  function FooterMetric() {
    var _this;
    _classCallCheck(this, FooterMetric);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "YM_PARAMS_KEY", 'footer_ev_');
    _defineProperty(_assertThisInitialized(_this), "setParamsPageInfo", function (params) {
      if (typeof window === 'undefined') return _defineProperty({}, _this.YM_PARAMS_KEY, _objectSpread({}, params));
      var authData = _this.getData();
      var accountType = getAccountType(authData);
      return _defineProperty({}, _this.YM_PARAMS_KEY, _objectSpread({
        account_type: accountType,
        page_title: document.title,
        page_url: window.location.href,
        page_path: window.location.pathname
      }, params));
    });
    return _this;
  }
  _createClass(FooterMetric, [{
    key: "handleClickLink",
    value: function handleClickLink(data) {
      var parseData = JSON.parse(data);
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'link',
        link_text: parseData.link_text,
        link_url: parseData.link_url
      }));
    }
  }, {
    key: "onViewFooter",
    value: function onViewFooter() {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'view',
        item_type: 'footer'
      }));
    }
  }, {
    key: "handleClickIcon",
    value: function handleClickIcon(data) {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'icon',
        icon_name: data
      }));
    }
  }, {
    key: "onSubscribeEmail",
    value: function onSubscribeEmail() {
      this.sendParamsEvent(this.setParamsPageInfo({
        action: 'click',
        item_type: 'button',
        button_text: 'подписаться',
        object_type: 'block',
        block_title: 'подписаться на рекламу'
      }));
    }
  }]);
  return FooterMetric;
}(YMMetricHelper);
var footerMetric = new FooterMetric({
  counterId: 26001372,
  isEcommerce: false,
  debug: true,
  selector: selectUserAuth
});
var _createMetric = createMetric({
    footerMetric: footerMetric
  }, 'debug'),
  Metric = _createMetric.Metric,
  withMetricContainer = _createMetric.withMetricContainer,
  decorateHandler = _createMetric.decorateHandler;
export { Metric, withMetricContainer, decorateHandler };